import { render, staticRenderFns } from "./PurchaseXiangQing.vue?vue&type=template&id=09a6772c&scoped=true"
import script from "./PurchaseXiangQing.vue?vue&type=script&lang=js"
export * from "./PurchaseXiangQing.vue?vue&type=script&lang=js"
import style0 from "./PurchaseXiangQing.vue?vue&type=style&index=0&id=09a6772c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a6772c",
  null
  
)

export default component.exports